import React, { useRef, useState } from 'react'
import { ButtonHLPure, HeaderHLPure } from '../../../pures'
import { useTranslation } from 'react-i18next'
import { Grid } from '@material-ui/core';

const CODE_LENGTH = new Array(6).fill(0)

function ValidateOTPForm(props) {
    const { user, onReSendMessage, onSubmitStep } = props;
    const { t } = useTranslation()

    const inputRef = useRef()
    const [focused, setFocused] = useState(false)
    const [code, setCode] = useState("")

    const handleChange = (e) => {
        const value = e.target.value.trim()
        setCode(value)
        if (value.length === CODE_LENGTH.length) {
            onSubmitStep(value)
        }
    }

    const focusInput = () => {
        inputRef.current.focus()
    }

    return (
        <Grid container className='validateOTP-code' spacing={1}>
            <Grid item xs={12}>
                <HeaderHLPure title={t("registration.action.otp")} headingNumber={2} />
            </Grid>
            <Grid item xs={12}>
                <p>{t('messagePure.description')}</p>
                <p className='validateOTP-email'>{user?.email}</p>
            </Grid>
            <Grid item xs={12} className="validateOTP-input">
                <input
                    autoFocus
                    ref={inputRef}
                    onFocus={() => setFocused(true)}
                    onBlur={() => setFocused(false)}
                    inputMode="numeric"
                    value={code}
                    onChange={handleChange}
                    className="validateOTP-hidden-input"
                />

                <div className='validateOTP-code'>
                    {CODE_LENGTH.map((_, index) => {
                        const selected = code.length === index || (code.length === CODE_LENGTH.length && index === CODE_LENGTH.length - 1)

                        return (
                            <div
                                onClick={focusInput}
                                className={`validateOTP-digit ${selected && focused ? "validateOTP-digit-focused" : ""}`}
                            >
                                <span>{code[index]}</span>
                            </div>
                        )
                    })}
                </div>

                <ButtonHLPure
                    nameBtn={t('messagePure.resendCode')} colorScheme="text"
                    onClick={onReSendMessage}
                />
            </Grid>
        </Grid>
    )
}

export default ValidateOTPForm